export default {
    egateeUserCenter: "Egatee User Center",
    mayTheForceBeWithU: "May the force be with you",
    egatee: "Egatee",
    jde: "Jde",
    egateeShopCenter: "Egatee Shop Center",
    egateeGlobalCommandCenter: "Egatee Global Command Center",
    egateeCountrySite: "Egatee Country Site",
    shopCenter: "Shop Center",
    globalCommandCenter: "Global Command Center",
    countrySite: "Country Site",
    suppliersSettled: "Shop Settled",
    supplierInformation: "Shop Information",
    subjectInformation: "Subject Information",
    mmdc: 'MMDC',
    mmdc_title:"MMDC-Data"
}